module.exports = __webpack_public_path__ + "img/noir-polar-logo.cab77956.png";